module.exports = __webpack_public_path__ + "static/media/img5.a7641513.jpg";